// extracted by mini-css-extract-plugin
export var borderRadius = "_6t-4";
export var large = "_6t-3";
export var logoContainer = "_6t-0";
export var nameLogo = "_6t-2";
export var small = "_6t-1";